import { useContext } from 'react';
import { MessageContext } from '../context/AlertContextProvider';

function useAlert() {

    const {
        AlertMessage
    } = useContext(MessageContext)
    return {
        AlertMessage
    }
}

export default useAlert;